import React, { useEffect } from 'react'; // ИЗМЕНЕНИЕ: импортируем useEffect

const CreateProjectModal = ({ 
  show, 
  projectName, 
  setProjectName, 
  projectColor, 
  setProjectColor, 
  onClose, 
  onCreateProject
}) => {
  // Определяем палитру цветов внутри компонента
  const colorOptions = [
    '#66d9ef', '#f92672', '#a6e22e', '#fd971f', '#ae81ff', '#ffffff', 
    '#f44336', '#2196f3', '#4caf50', '#ffc107', '#9c27b0', '#795548'
  ];

  // =================================================================
  // НОВОЕ: Хук для установки цвета по умолчанию
  // Этот код сработает, как только модальное окно откроется (когда `show` станет true)
  // =================================================================
  useEffect(() => {
    // Если окно открыто И цвет еще не выбран
    if (show && !projectColor) {
      // Устанавливаем самый первый цвет из нашего списка как цвет по умолчанию
      setProjectColor(colorOptions[0]);
    }
  }, [show, projectColor, setProjectColor]); // Зависимости эффекта

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Создать новый проект</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="projectName" className="form-label">Название проекта</label>
                <input
                  type="text"
                  className="form-control"
                  id="projectName"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                  placeholder="Введите название проекта"
                  autoFocus
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Цвет папки</label>
                <div className="color-picker-grid">
                  {colorOptions.map(color => (
                    <div
                      key={color}
                      className={`color-option ${projectColor === color ? 'selected' : ''}`}
                      style={{ backgroundColor: color }}
                      onClick={() => setProjectColor(color)}
                      title={color}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Отмена
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={onCreateProject}
                disabled={!projectName.trim()}
              >
                Создать проект
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
      ></div>
    </>
  );
};

export default CreateProjectModal;